export class DownloadCache {
  static indexCacheKey() {
    return 'downloads';
  }
}
